<template>
  <bimRow class="block-how-it-works py-12 d-flex flex-column">
    <bim-text class="block-how-it-works__title pb-12" type="h5" bold>Как это работает?</bim-text>
    <bimRow class="how-it-works d-flex flex-column mb-11 mx-auto">
      <bimCol 
        v-for="(item, index) of items"
        :key="index"
        class="how-it-works-item d-flex align-center"
        :class="index % 2 ? 'right' : 'left'"
      >
        <img :src="item.image" alt="" class="how-it-works-item__image" />
        <bim-text type="main" class="how-it-works-item__text">{{ item.text }}</bim-text>
      </bimCol>
    </bimRow>
    <bimRow class="d-flex justify-center">
      <ButtonTryService />
    </bimRow>
  </bimRow>
</template>

<script>
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"

import ButtonTryService from "./ButtonTryService"
export default {
  name: "BlockHowItWorks",
  components: {
    bimRow,
    bimCol,

    ButtonTryService
  },
  data() {
    return {
      items: [
        { 
          image: "/dist/assets/front_white/img/landing_gisp/img-landing-gisp-6.svg",
          text: "Зарегистрированный пользователь в ГИСП добавляет продукцию по требованиям ПП1604."
        },
        { 
          image: "/dist/assets/front_white/img/landing_gisp/img-landing-gisp-7.svg",
          text: "Сервис BIMLIB на основании введённых данных создает цифровые паспорта продукции."
        },
        { 
          image: "/dist/assets/front_white/img/landing_gisp/img-landing-gisp-8.svg",
          text: "Пользователю рекомендуется дополнить информацию о нормативно-технических документах и расширить перечень свойств продукции, если их нет в ГИСП. "
        },
        { 
          image: "/dist/assets/front_white/img/landing_gisp/img-landing-gisp-9.svg",
          text: "Благодаря удобному интерфейсу пользователю предоставляется возможность для работы с цифровыми паспортами продукции: актуализация данных о продукции, выгрузка в удобном формате excel, поиск аналогов"
        },
        { 
          image: "/dist/assets/front_white/img/landing_gisp/img-landing-gisp-10.svg",
          text: "Мониторинг проектной потребности, формирование ТКП по прямым запросам пользователей BIMLIB."
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/grid-settings";

.block-how-it-works {

  .block-how-it-works__title {
    width: 100%;
    line-height: 1.13;
    text-align: center;
  }
}

.how-it-works {

  .how-it-works-item {
    max-width: 800px;
  }

  .how-it-works-item.left {
    justify-content: flex-start;
    .how-it-works-item__image {
      margin-right: 29px;
      order: 0;
    }
  }

  .how-it-works-item.right {
    justify-content: flex-end;
    .how-it-works-item__image {
      margin-left: 29px;
      order: 1;
    }
  }

  .how-it-works-item:not(:last-child) {
    padding-bottom: 24px;

    @media screen and (max-width: $breakpoint-sm) {
      padding-bottom: 42px;
    }
  }

  .how-it-works-item__text {
    line-height: 1.5;
    letter-spacing: 0.2px;
  }

  @media screen and (max-width: $breakpoint-sm) {
    .how-it-works-item.left,
    .how-it-works-item.right {
      flex-direction: column;

      .how-it-works-item__image {
        margin: 0 0 20px;
        order: 0;
        width: 100px;
      }
    }
  }
}
</style>
